import styled from 'styled-components';
import { Alert } from '@dexma/ui-components';

export const StyledAlert = styled(Alert)`
    .message {
        width: 100%;
    }

    .description {
        width: 100%;
    }
`;
